/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import Markdown from 'react-markdown'
// eslint-disable-next-line
import React from 'react'

import fontSizes from '../../utils/constants/fontSizes'
const parseLinks = text => {
  const str = String(text || '')

  if (/\[.*?\]\(.*?\)/.test(str) || /<img[^>]+src=/.test(str)) {
    return str
  }

  return str.replace(/\b((https?:\/\/)?([\w-]+\.)+([a-z]{2,})(\/[^\s]*)?)\b/gi, match => {
    const hasProtocol = match.startsWith('http')
    const url = hasProtocol ? match : `http://${match}`
    return `[${match}](${url})`
  })
}
const _Markdown = ({ children, value, color, fontFamily, noMargin }) => {
  const style = css`
    font-family: ${fontFamily || `'SF Pro Display', 'Nunito', sans-serif !important`};
    line-height: 1.7;
    color: ${color || COLORS.dark3};
    white-space: pre-line;
    overflow-wrap: break-word;

    & p {
      margin: 0;
      margin-bottom: ${noMargin ? 0 : '0.75rem'};
    }

    & hr {
      border: solid 1px ${COLORS.light3};
    }

    & h1 {
      font-size: ${fontSizes.h4}rem;
    }
    & h2 {
      font-size: ${fontSizes.h5}rem;
    }
    & h3 {
      font-size: ${fontSizes.h6}rem;
    }
    & h4 {
      font-size: ${fontSizes.small}rem;
    }
    & h5 {
      font-size: ${fontSizes.xsmall}rem;
    }
    & h6 {
      font-size: ${fontSizes.xsmall}rem;
    }

    & a,
    & a:visited {
      color: ${COLORS.purple};
      font-weight: 400;
      text-decoration: none;
    }

    & img {
      max-width: 100%;
    }

    & ul,
    & ol {
      margin: 0;
      padding-left: 1rem;
    }

    & code {
      padding: 2px 3px;
      background: #f5f6f8;
      border: solid 1px #d8d9e6;
      color: tomato;
      border-radius: 2px;
    }
    & pre code {
      background: none;
      border: none;
      color: white;
      padding: 0;
    }

    & pre {
      color: white;
      background: #2d333b;
      padding: 0.5rem;
      border-radius: 5px;
    }
  `

  const content = parseLinks(children || value || '')

  return (
    <div css={style} className="markdown">
      <Markdown linkTarget="_blank">{content}</Markdown>
    </div>
  )
}

export default _Markdown
